<template>
	<header @click.stop id="header-ct" v-if="headerType" :class="{ 'nav-is-visible': isMobileMenuOpened, 'scrolled-down': scrollDown, 'with-sections': canShowSections }">
		<template
			v-if="headerType === 'main' || headerType === 'no-checkout'" 
		>
			<div id="header" v-if="$mq.isDesktop()">
				
				<logo />

				<div class="menu">
					<nav class="main-nav">

						<div class="profile-link " v-if="!$mq.isDesktop() && loggedIn">
							<div class="name-nav">
								<span>{{ $t("components.navigation.greeting") }} </span>
								<span v-if="user.firstname" class="capitalize">{{user.firstname}}</span>
							</div>

							<router-link :to="{name: 'profile'}" class='nav-item my-profile-btn'>
								{{ $t("components.navigation.your_profile") }} <i aria-hidden="true" class="fas fa-user"></i>
							</router-link>
						</div>

		
						<router-link :to="{name: 'flow-subscribed'}" class="nav-item">
							<span v-if="$root.source == 'bennet'" class="capitalize">Fai la tua spesa</span>
							<span v-else>Ordina ora</span>
						</router-link>

						<router-link :to="{ name: 'how-it-works' }" class='nav-item'>
							<span :class="{'capitalize': $root.source == 'bennet'}">{{ $t("components.navigation.links.our_abo") }}</span>
						</router-link>
						<!-- Riattivare quando no gift card -->
						<!-- <router-link :to="{ name: 'suppliers' }" class='tag-partner nav-item'>
							I nostri produttori
						</router-link> -->

						<!-- Commentare quando non più necessario -->
						<router-link :to="{ name: 'gift-card' }" class='tag-partner nav-item'>
							Gift Card
						</router-link>

						<router-link :to="{ name: 'how-we-recycle' }" class='nav-item'>
							<span :class="{'capitalize': $root.source == 'bennet'}">Sostenibilità</span>
						</router-link>

						<!-- <router-link :to="{ name: 'landing-b2b' }" class='nav-item'>
							Per le aziende
						</router-link> -->

						<router-link :to="{ name: loggedIn ? 'freshdesk' : 'faq' }" class='nav-item'>
							<span :class="{'capitalize': $root.source == 'bennet'}">Aiuto</span>
						</router-link>

						<a v-if="$root.source == 'bennet'" href="https://www.bennet.com/" class="nav-item capitalize">Bennet.<span class="lowercase">c</span>om</a>

						<a href="#" @click="logout()" class="nav-item" v-if="!$mq.isDesktop() && loggedIn">{{ $t("auth.logout.logout") }}</a>
					</nav>
					<div style="flex-grow:1"></div>
					<template v-if="$mq.isDesktop() && headerType == 'main'">
						<div v-if="!loggedIn" class="login-group flex-right">

							<CTA
								:content="$t('auth.signin.button')"
								@click="openModal('signin')"
								:size="`small`"
								:color="`transparent`"
								:style="$root.source == 'bennet' ? 'text-transform: capitalize !important' : ''"
							/>

							<CTA
								class="tag-partner"
								:content="$t('auth.signup.button')"
								@click="openModal('signup')"
								:color="`orange`"
								:size="`small`"
							/>

						</div>

						<div class="flex-right" style="display:flex; align-items: center">
						
							
							<nav-profile-drop-down-menu class="mr-3"/>
							<div class="tag-partner">
								<v-tooltip bottom color="var(--quomi-primary)" v-if="loggedIn && hasPaidOrders">
									<template v-slot:activator="{on}">
										<v-btn  v-on="on" class="mx-3" color="var(--quomi-primary)" outlined icon>
											<router-link :to="{name: 'profile_orders'}">
												<i class="fas fa-sync-alt" :style="$root.source === 'bennet' ? 'color: white' : 'color: var(--quomi-primary)'"></i>
											</router-link>
										</v-btn>
									</template>
									<span>Riordina l'ultima spesa</span>
								</v-tooltip>
							</div>
							
							<delivery-widget v-if="$mq.isDesktop() && canShowWidgets" />

							<billing-cart class="ml-3 mr-5" v-if="canShowWidgets"/>

						</div>
					</template>

					<template v-if="!$mq.isDesktop() && headerType == 'main'">

						<div v-if="!loggedIn" class="login-group">

							<CTA
								:content="$t('auth.signin.button')"
								@click="openModal('signin')"
								:size="`small`"
								:color="`transparent`"
							/>

							<CTA
								class="tag-partner"
								:content="$t('auth.signup.button')"
								@click="openModal('signup')"
								:color="`orange`"
								:size="`small`"
							/>

						</div>
					</template>

				</div>

			</div>


			
		</template>
	   <div id="header" v-if="!$mq.isDesktop()">
        <div class="menu">
          <nav class="main-nav">

            <div class="profile-link " v-if="loggedIn">
              <div class="name-nav">
                <span>{{ $t("components.navigation.greeting") }} </span>
                <span v-if="user.firstname" class="capitalize">{{user.firstname}}</span>
              </div>
            </div>

            <div v-else>
              <CTA
                :content="$t('auth.signin.button')"
                @click="openModal('signin')"
                :size="`small`"
                :color="`transparent`"
                :style="$root.source === 'bennet' ? 'color: var(--quomi-text) !important' : ''"
              />

              <CTA
              class="tag-partner"
              :content="$t('auth.signup.button')"
              @click="openModal('signup')"
              :color="`orange`"
              :size="`small`"
              />
            </div>

            <router-link :to="{ name: 'dashboard' }" class='nav-item tag-partner' >
              Home
            </router-link>

						<router-link :to="{ name: 'gift-card' }" class='nav-item tag-partner'>
              Gift card
            </router-link>
            
            <router-link v-if="$root.source === 'bennet'" :to="{ name: 'how-it-works' }" class='nav-item'>
              {{ $t("components.navigation.links.our_abo") }}
            </router-link>

            <router-link v-if="$root.source === 'bennet'" :to="{name: 'flow-subscribed'}" class="nav-item">
              <span>Fai la tua spesa</span>
            </router-link>

            <div class="tag-partner" style="margin-bottom: 15px; border-bottom: 1px solid #efefef;width: 100%">&nbsp;</div>
            
            <router-link 
              v-for="(section, i) in recipeSections.items" 
              :key="i" 
              :to="{ name: 'shop-by-tag', params: {tag: section.url} }"
              class="pa-1 tag-partner"
              style="width: 100%"
            >
              <v-card
              class="center"
              >
                  <v-img :src="section.img"></v-img>
                  <span class="text-bold" style="font-size: 13px">{{section.name}}</span>
              </v-card>
            </router-link> 

            <div class="flex flex-wrap tag-partner">
              <router-link         
              v-for="(section, i) in extraSections.items.slice(0,11)"
              :key="i"
              :to="{ name: 'shop-by-tag', params: {tag: section.url} }"
              class="pa-1"
              style="width: 50%"
              :style="section.name === 'Cassette' || section.name === 'Natale' ? 'width: 100%' : ''"
              >
                <v-card 
                class="center"
                >
                  <v-img :src="section.img"></v-img>
                  <span class="text-bold" style="font-size: 10px">{{section.name}}</span>
                </v-card>
              </router-link>
            </div>
            <div style="margin-bottom: 15px; border-bottom: 1px solid #efefef;width: 100%">&nbsp;</div>

            <div v-if="loggedIn">
              
              <router-link :to="{name: 'profile'}" class='nav-item my-profile-btn'>
                {{ $t("components.navigation.your_profile") }} <i aria-hidden="true" class="fas fa-user"></i>
              </router-link>
              
              <router-link :to="{ name: 'profile_orders' }" class='nav-item' v-if="isSubscribed">
                La mie spese
              </router-link>

              <router-link :to="{ name: 'profile_account' }" class='nav-item'>
                Account
              </router-link>
              
              <router-link :to="{ name: 'profile_subscription' }" class='nav-item tag-partner' v-if="isSubscribed">
                Abbonamento
              </router-link>

              <router-link :to="{ name: 'profile_shipment' }" class='nav-item' v-if="isSubscribed">
                Indirizzo e giorno consegna
              </router-link>

              <router-link :to="{ name: 'profile_invite-friend' }" class='nav-item tag-partner' v-if="isSubscribed">
                Invita un amico
              </router-link>

              <div style="margin-bottom: 15px; border-bottom: 1px solid #efefef;width: 100%">&nbsp;</div> 
            </div>

            <router-link :to="{ name: 'how-it-works' }" class='nav-item tag-partner'>
              {{ $t("components.navigation.links.our_abo") }}
            </router-link>

            <router-link :to="{ name: 'suppliers' }" class='nav-item tag-partner'>
              I nostri produttori
            </router-link>

            <router-link :to="{ name: 'how-we-recycle' }" class='nav-item'>
              Sostenibilità
            </router-link>

            <!-- <router-link :to="{ name: 'gift-card' }" class='nav-item tag-partner'>
                Gift card
            </router-link> -->

            <router-link :to="{ name: loggedIn ? 'freshdesk' : 'faq' }" class='nav-item'>
              Aiuto
            </router-link>

            <div v-if="$root.source === 'bennet'" style="margin-bottom: 15px; border-bottom: 1px solid #efefef;width: 100%">&nbsp;</div>

            <a v-if="$root.source === 'bennet'" class='nav-item' href="https://www.bennet.com/">Bennet.com</a>
          </nav>
        </div>
        
        <div style="width: 25%">
        </div>
        
        <div
          class="nav-trigger"
          @click="toggleMobileMenu()"
        >
          <span />
        </div>

        <div style="width: 50%; text-align: center">
          <logo class="ma-auto mt-1"/>
        </div>

        <div class="flex-right" style="width: 25%; display:flex; align-items: center; justify-content: flex-end">       
          <!--<delivery-widget v-if="canShowSections" />-->
          <CTA
            v-if="$root.source === 'bennet' && !loggedIn"
            :content="$t('auth.signin.button')"
            @click="openModal('signin')"
            :size="`small`"
            :color="`transparent`"
            :style="$root.source == 'bennet' ? 'text-transform: capitalize !important' : ''"
          />
          <billing-cart class="mt-2 ml-3 mr-4" v-if="canShowWidgets"/>
        </div>

      </div>

		<template 
			v-if="headerType === 'checkout'"
		>

      <div class="steps-nav flex flex-wrap justify-content-center py-3 tag-partner" v-if="!$mq.isDesktop()">
        <router-link v-if="isUserPending" :to="{ name: 'plans' }">
          <img src="https://api.quomi.it/oldimg/package.png" class="default-icon mr-2" v-if="$mq.isDesktop()"/>
          <img src="https://api.quomi.it/oldimg/package-%281%29.png" class="active-icon mr-2" v-if="$mq.isDesktop()"/>
          Personalizza
        </router-link>
        <router-link 
          v-for="(sectionPage, i) in sectionPages" :to="sectionPage.firstUrl" :class="{'router-link-exact-active router-link-active': isSectionPageActive(sectionPage)}">
          <img :src="sectionPage.icon" class="default-icon mr-2" v-if="$mq.isDesktop()"/>
          <img :src="sectionPage.activeIcon" class="active-icon mr-2" v-if="$mq.isDesktop()"/>
          {{sectionPage.name}}
        </router-link>
        <span :class="{'router-link-exact-active router-link-active': ['verify-page','flow-new'].indexOf($route.name) !== -1}">
          <img src="https://api.quomi.it/oldimg/delivery-truck-%281%29.png" class="default-icon mr-2" v-if="$mq.isDesktop()"/>
          <img src="https://api.quomi.it/oldimg/delivery-truck.png" class="active-icon mr-2" v-if="$mq.isDesktop()"/>
          Cassa
        </span>
      </div>

			<div id="header" class="checkout flex-center" v-else>
				<logo class="checkout-logo" style='justify-content: flex-start;' />

				<div class="steps-nav text-center checkout-main" v-if="$mq.isDesktop()">
					<router-link v-if="isUserPending" :to="{ name: 'plans' }" class="tag-partner">
						<img src="https://api.quomi.it/oldimg/package.png" class="default-icon mr-2"/>
						<img src="https://api.quomi.it/oldimg/package-%281%29.png" class="active-icon mr-2"/>
						<span class="link-big-detail">Personalizza</span>
					</router-link>
					<router-link v-for="(sectionPage, i) in sectionPages" :key="i" :to="sectionPage.firstUrl" :class="{'router-link-exact-active router-link-active': isSectionPageActive(sectionPage)}">
						<img :src="sectionPage.icon" class="tag-partner default-icon mr-2"/>
						<img :src="sectionPage.activeIcon" class="tag-partner active-icon mr-2"/>
						<span class="link-big-detail">{{sectionPage.name}}</span>
					</router-link>
					<span :class="{'router-link-exact-active router-link-active': ['verify-page','flow-new'].indexOf($route.name) !== -1}">
						<img src="https://api.quomi.it/oldimg/delivery-truck-%281%29.png" class="default-icon tag-partner mr-2"/>
						<img src="https://api.quomi.it/oldimg/delivery-truck.png" class="active-icon tag-partner mr-2"/>
						<span class="link-big-detail">Cassa</span>
					</span>
				</div>


				<div class="flex flex-vcenter" style='justify-content:flex-end; width: 25%;'>
          <!--<div v-if="!loggedIn" class="login-group flex-right">
            <CTA
              :content="$t('auth.signin.button')"
              @click="openModal('signin')"
              :size="`small`"
              :color="`transparent`"
              :style="$root.source == 'bennet' ? 'text-transform: capitalize !important' : ''"
            />

            <CTA
              class="tag-partner"
              :content="$t('auth.signup.button')"
              @click="openModal('signup')"
              :color="`orange`"
              :size="`small`"
            />
          </div>-->
					<nav-profile-drop-down-menu class="mr-3"  v-if="canShowWidgets"/>
					<div class="tag-partner"  v-if="canShowWidgets">
						<v-tooltip bottom color="var(--quomi-primary)" v-if="loggedIn && hasPaidOrders">
							<template v-slot:activator="{on}">
								<v-btn  v-on="on" class="mx-3" color="var(--quomi-primary)" outlined icon>
									<router-link :to="{name: 'profile_orders'}">
										<i class="fas fa-sync-alt" :style="$root.source === 'bennet' ? 'color: white' : 'color: var(--quomi-primary)'"></i>
									</router-link>
								</v-btn>
							</template>
							<span>Riordina l'ultima spesa</span>
						</v-tooltip>
					</div>
					
          <delivery-widget v-if="$mq.isDesktop() && canShowWidgets" :showCity="false"/>

          <billing-cart class="ml-3 mr-3" v-if="canShowWidgets"/>
				</div>
			</div>
		</template>


		<template
			v-if="headerType === 'empty-with-review'"
		>
			<div id="header" class="checkout flex-center">
				
				<logo
					nolink
				/>		

				<div class="overlay-container">
					<div class="overlay" />
					<feedaty
						:isSmall="true"
						:uid="4"
					/>
					<div class="info-small-normal center">Recensioni da FEEDATY</div>
				</div>
			</div>
		</template>

		<template
			v-if="headerType === 'empty-with-centered-logo'"
		>
			<div id="header" class="checkout centered">
				<logo
					nolink
				/>		
			</div>
		</template>



		<template
			v-if="headerType === 'investors'" 
		>
			<div id="header">
				
				<logo />

				<div class="menu">
					<nav class="main-nav">
						<a href="#" @click="scrollToElement('results')" class='nav-item'>
							Risultati
						</a>
						<a href="#" @click="scrollToElement('collaboration')" class='nav-item'>
							Collaborazioni
						</a>
						<a href="#" @click="scrollToElement('team')" class='nav-item'>
							Team
						</a>
						<a href="#" @click="scrollToElement('how')" class='nav-item'>
							Come funziona
						</a>
						<a href="#" @click="scrollToElement('join')" class='nav-item'>
							Unisciti a Noi
						</a>
					</nav>

					<template v-if="$mq.isDesktop()">
						<div class="flex flex-vcenter flex-right">
							<a href="https://www.crowdfundme.it/projects/quomi/" target="_blank">
								<CTA
									:content="`Investi ora`"
									:size="`small`"
								/>
							</a>
						</div>
					</template>
				</div>

				<div
					class="nav-trigger"
					@click="toggleMobileMenu()"
				>
					<span />
				</div>
			</div>

		</template>


        <div v-if="canShowSections" class="section-alt">
            <SliderQ
							v-if="!$mq.isDesktop()"
							:maxNumSlides="sections.length"
							:minSizeOfSlide="110"
							class="section-container"
							:arrows="!$mq.isDesktop()"
            >
							<slide
								v-for="(section, index) in sections" 
								:class="{'active': isSectionEnabled(section)}" 
								class="section-item" 
								@click="changeSection(section)"
							>
								<span>{{ section.name }} </span>
							</slide>
            </SliderQ>

						<div v-else class="flex justify-content-center my-3">
							<div 
								v-for="(section, index) in sections" 
								:key="index"
								:class="{'active': isSectionEnabled(section)}" 
								class="section-item" 
								@click="changeSection(section)"
							>
								<div class="section-container-box" >
									<img v-if="!sticky" :src="!isSectionEnabled(section) ? section.icon.default || '' : section.icon.active || ''" width='42' height='42' />
									<span>{{ section.name }} </span>
                </div>
							</div>
						</div>
            <div class="border-top-checkout"> </div>
        </div>

		<banner-top v-if="!loggedIn" />
		<banner-greeting v-if="$route.name == 'home'" />

        <!--<menu-alert
            v-if="$route.name == 'shop-by-tag'"
        />-->

        <checkout-verify-coverage v-if="order" :open="!user"/>

    	<checkout-change-menu/>
	</header>
</template>

<script type = "text/javascript" >
import { container } from '../services/container'

import NavProfileDropDownMenu from './NavProfileDropDownMenu'
import DeliveryWidget from './Checkout/DeliveryWidget'
import CheckoutVerifyCoverage from './Checkout/CheckoutVerifyCoverage'
import CheckoutChangeMenu from './Delivery/CheckoutChangeMenu'
import BannerTop from './Parts/BannerTop'
import Logo from './Parts/Logo'
import BillingCart from './Checkout/BillingCart'
import BannerGreeting from './Parts/BannerGreeting'

import Feedaty from './Feedaty'

import { scrollToElementId } from '../assets/js/main'
import { dashboard } from '../mixins/dashboard'
import { sections } from '../mixins/sections'


export default {

	components: {
		CheckoutVerifyCoverage,
		CheckoutChangeMenu,
		Logo,
		BannerGreeting,
		NavProfileDropDownMenu,
    DeliveryWidget,
		BannerTop,
		Feedaty,
		BillingCart
	},

	watch: {
		'$route' () {
			this.isMobileMenuOpened = false
		}
	},

	mixins: [
    sections,
		dashboard
	],

	data () {
		return {
			isSubMenuOpened: false,
			isMobileMenuOpened: false,
			scrollDown: false,
			sticky: false,
			sectionsPath: [
					'thank-you', 
					'thank-you-recurring', 
					'thank-you-new', 
					'thank-you', 
					'flow-new', 
					'verify-page', 
					'home', 
					'plans', 
					'suppliers', 
					'how-we-recycle',
					'landing-b2b',
					'freshdesk',
          'order-now',
					'order-now-voiello',
					'order-now-boxes',
					'our-team',
					'how-it-works',
					'how-it-works/bennet', 
					'how-it-works/galbani',
					'faq',
					'gift-card',
					'invite-friend',
					'cookbook'
			],
			pathsWithSections : [
				'/checkout/cassette',
				'/checkout/carne-pesce',
				'/checkout/latticini-salumi',
				'/checkout/frutta-verdura',
				'/checkout/pasta-pane',
				'/checkout/colazioni',
				'/checkout/piatti-pronti',
				'/checkout/vini-birre',
				'/checkout/dispensa',
				'/checkout/aperitivo',
				'/checkout/pizze',
				'/checkout/natale'
			]
		}
	},

	computed: {
 
		recipeSections () {
      let recipeSections = JSON.parse(window.config["quomi.checkout.new-top-sections"])

      recipeSections = recipeSections.find(el => {return el.name === 'Kit Ricette' })
    
      return recipeSections
    },

		extraSections () {
      let extraSections = JSON.parse(window.config["quomi.checkout.new-top-sections"])

      extraSections = extraSections.find(el => {return el.name === 'Bottega' })
    
      return extraSections
    },

		user () {
			return this.$root.user
		},
		order () {
			return this.user ? this.user.order : null
		},
    isUserPending () {
      return !this.user || !this.user.subscription || this.user.subscription.status == 'pending'
    },
		isSubscribed(){
			return this.user.isSubscribed()
		},
		loggedIn () {
			return this.user && !this.user.email.includes('guest.quomi.it')
		},
		isEcommerce () {
			return this.$route.name === 'thank-you-ecommerce' || this.$route.name === 'ecommerce'
		},

		headerType () {
      let header = (this.$route.meta && this.$route.meta.header) ? this.$route.meta.header : null;

      if (this.$route.meta && this.$route.meta.header === false) {
        return null;
      }
      
      if (header) {

        if (header === 'checkout' && this.$root.source === 'bennet') {
          header = 'main';
        }

        return header;
      }

      return 'main'
		},

		showPlansLink () {
			if (this.user && this.user.isSubscribed()) return false
			return true
		},
		canShowSections() {
			if(this.pathsWithSections.includes(this.$route.path) && ((['shop', 'recipe', 'product']).indexOf(this.$route.name) <= 0)) return true
			return false;

			/* if(!this.canShowWidgets) return false
			if (this.$root.source === 'enel') return false
			if (['dashboard'].indexOf(this.$route.name) >= 0) return false
			return true; */

		},
		canShowWidgets() {
			if (
				this.sectionsPath.indexOf(this.$route.name) >= 0) {
				return false
			}
			return true;
		},

		hasPaidOrders() {
			if(this.user.stats.orders.count > 0) {
				return true
			}
			return false
		}
	},

	methods: {
		p (name) {
			return true;
		},


		isSectionEnabled(section) {
			return this.$route.name === 'shop-by-tag' && this.$route.params.tag == section.url
		},
		changeSection(section) {
			this.$router.push({name: 'shop-by-tag', params: {tag: section.url}})
			window.dispatchEvent(new CustomEvent('remove-filters', {bubbles: true}))
		},
		logout () {
			container.get('services.oauth').logout().then(i => {
				window.location.href = '/'
			})
		},

		openModal (target) {
			this.$emit('openModal', target)
		},

		toggleMobileMenu () {
			this.isMobileMenuOpened = !this.isMobileMenuOpened
		},

		scrollToElement (target) {
			scrollToElementId(target)
		},

		removeFilters() {
			window.dispatchEvent(new CustomEvent('remove-filters', {bubbles: true}))
		}
	},

	mounted () {
		var currentPosition = 0

		this.$nextTick(function () {
			window.addEventListener('scroll', () => {
				var scrollDown = () => window.scrollY > currentPosition && window.scrollY > 100
				//this.scrollDown = !!scrollDown()
				currentPosition = window.scrollY
			})
		})

		// hide mobile menu by clicking out of diiv
		var e = document.getElementById('app')
		e.addEventListener('click', () => {
			if (this.isMobileMenuOpened === true) this.toggleMobileMenu()
		})

        window.addEventListener('scroll', (e) => {
            this.sticky = window.pageYOffset > 250;
        })
	}
}

</script>

<style scoped>
	#header-ct {
		position: fixed;
		z-index: 6;
		box-shadow: 0px 2px 3px rgba(0,0,0,0.1);
		width: 100%;
		transition: all ease 0.5s;
		background: white;
	}

	.bg-h {
		background-color: var(--quomi-background-header);
	}

	#header {
		display: flex !important;
		flex-wrap: nowrap;
		align-content: flex-start;
		justify-content: flex-start;
		height: 80px;
		width: 100%;
		background-color: white;
		box-shadow: 0px 2px 3px rgba(0,0,0,0.1);
		background-color: var(--quomi-background-header);
		padding: 0 10px;

	}

	.scrolled-down {
		transform: translateY(-80px);
	}

	#header.checkout {
		justify-content: space-between;
	}

	#header.centered {
		justify-content: center;
	}

	.center {
		text-align: center;
	}
	.main-nav .nav-item{
		-webkit-transition: -webkit-transform 0.3s, opacity 0.3s;
		-moz-transition: -moz-transform 0.3s, opacity 0.3s;
		transition: transform 0.3s, opacity 0.3s;
		padding: 8px 15px;
	}

	.nav-item.sub {
		padding-left: 30px;
	}

  .checkout-nav-padding {
    padding-left: 125px;
  }

	.main-nav {
		display: flex;
		justify-content: center;
		align-items: center;
		-webkit-transition: -webkit-transform 0.3s;
		-moz-transition: -moz-transform 0.3s;
		transition: transform ease 0.3s;
	}

	.menu {
		display: flex;
		flex-basis: 100%;
	}

	.profile-link .name {
		font-size: 13px;
	}

	.dd-menu-login a {
		display: block;
		padding: 5px 0;
	}

	.triangle-outer,
	.triangle-inner  {
		position: absolute;
		top: -10px;
		right: 19%;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
	}

	.triangle-outer {
		border-bottom: 10px solid #aba8a8;
	}

	.triangle-inner {
		border-bottom: 11px solid white;
	}

	.dd-menu-login p {
		margin: 0 0 10px 0;
	}

	.profile-link {
		padding: 10px 17px 10px 0;
	}

	.how-it-works {
		position: relative;
		padding: 10px 0;
	}

	.how-it-works .dd-menu {
		display: none;
	}

	.dd-menu {
		margin-top: 8px;
		width: 220px;
		display: none;
		position: absolute;
		background: white;
		line-height: 1.3;
		text-align: left;
		padding: 10px;
		border: 1px solid #e8e8e8;
		border-radius: 3px;
		right: -33px;
	}

	.dd-menu a {
		display: block;
	}

	.how-it-works:hover .dd-menu {
		display: block;
	}

	.login-group {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.login-group .btn {
		width: 100%;
	}

	.router-link-exact-active {
		color: var(--quomi-primary);
		font-weight: bold;
	}

	.nav-item:hover{
		color: var(--quomi-primary);
	}

	.nav-item {
		display: block;
	}

	.main-nav .nav-item.submenu {
		margin-left: 23px;
	}

	.my-profile-btn,
	.my-profile-btn:hover,
	.my-profile-btn:focus {
		background-color: transparent;
		border-color: transparent;
		font-weight: bold;
		color: var(--quomi-primary);
		text-transform: uppercase;
	}

	.my-profile-btn .fa {
		padding-left: 5px;
		padding-bottom: 1px;
	}

	.rebuy-btn {
		border: 1px solid var(--quomi-primary);
		border-radius: 5px;
		color: var(--quomi-primary);
		padding: 2px 10px;
		font-size: 21px;
	}

	.overlay-container {
		position: relative;
	}

	.overlay {
		position: absolute;
		z-index: 1;
		width: 100%;
		height: 100%;
	}

	.steps-nav > * {
		padding: 0 1em;
		display: inline-flex;
		align-items: center;
	}

	.steps-nav > *:not(.router-link-active) > img.active-icon {
		display: none;
	}

	.steps-nav > *:is(.router-link-active) > img.default-icon {
		display: none;
	}

	.steps-nav > *:is(.router-link-active) {
		text-decoration: underline;
		text-underline-offset: 2px;
	}

	.checkout-logo {
		width: 25%;
	}

	.checkout-main {
		width: 50%;
		padding-top: 5px;
	}

	@media (max-width: 1600px) {

		.steps-nav > * {
			font-size:13px;
			padding: 0 0.5em;
		}

		/* .checkout-logo {
			width: 5%;
		} */

		/* .checkout-main {
			width: 70%;
		} */
	}

	@media (max-width: 1024px) {
		#header {
			height: 50px !important;
			box-shadow: 0px 2px 3px rgba(0,0,0,0.1);
		}

		.nav-is-visible {
			transform: translateX(275px);
		}

		.scrolled-down {
			transform: translateY(-50px);
		}
		.menu {
			position: absolute;
			overflow: auto;
			left: -275px;
			height: 100vh;
			width: 275px;
			padding: 15px;
			display: block;
			background: white;
			font-size: 20px;
			text-align: left;
			z-index: 4;
		}

		.name-nav {
			margin-left: 15px;
			font-size: 15px;
		}

		.login-group {
			justify-content: flex-start;
			flex-flow: column;
			align-items: flex-start;
			margin: 0 15px;
		}

		.login-group .btn {
			margin: 5px 0;
		}

		.login-group .btn-transparent {
			border: 2px solid orange;
		}

		.main-nav {
			display: flex;
			flex-flow: column;
			align-items: flex-start;
			justify-content: flex-start;
		}

		.nav-trigger {
			display: block;
			position: absolute;
			left: 0;
			top: 0;
			height: 100%;
			width: 50px;
			cursor: pointer;
			overflow: hidden;
			white-space: nowrap;
			color: transparent;
		}

		.nav-trigger span {
			position: absolute;
			height: 2px;
			width: 20px;
			top: 25px;
			margin-top: -1px;
			left: 25px;
			margin-left: -10px;
			-webkit-transition: background-color 0.3s 0.3s;
			-moz-transition: background-color 0.3s 0.3s;
			transition: background-color 0.3s 0.3s;
			background-color: black;
		}

		.nav-trigger span:before, .nav-trigger span:after {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			background-color: black;
			/* Force Hardware Acceleration */
			-webkit-transform: translateZ(0);
			-moz-transform: translateZ(0);
			-ms-transform: translateZ(0);
			-o-transform: translateZ(0);
			transform: translateZ(0);
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			-webkit-transition: -webkit-transform 0.3s 0.3s;
			-moz-transition: -moz-transform 0.3s 0.3s;
			transition: transform 0.3s 0.3s;
		}

		.nav-trigger span:before, .nav-trigger span:after {
			/* upper and lower lines of the menu icon */
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			background-color: black;
			/* Force Hardware Acceleration */
			-webkit-transform: translateZ(0);
			-moz-transform: translateZ(0);
			-ms-transform: translateZ(0);
			-o-transform: translateZ(0);
			transform: translateZ(0);
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			-webkit-transition: -webkit-transform 0.3s 0.3s;
			-moz-transition: -moz-transform 0.3s 0.3s;
			transition: transform 0.3s 0.3s;
		}

		.nav-trigger span:before {
			-webkit-transform: translateY(-6px);
			-moz-transform: translateY(-6px);
			-ms-transform: translateY(-6px);
			-o-transform: translateY(-6px);
			transform: translateY(-6px);
		}

		.nav-trigger span:after {
			-webkit-transform: translateY(6px);
			-moz-transform: translateY(6px);
			-ms-transform: translateY(6px);
			-o-transform: translateY(6px);
			transform: translateY(6px);
		}

		.nav-is-visible .nav-trigger span {
			background-color: rgba(255, 255, 255, 0);
		}

		.nav-is-visible .nav-trigger span:before {
			-webkit-transform: translateY(0) rotate(-45deg);
			-moz-transform: translateY(0) rotate(-45deg);
			-ms-transform: translateY(0) rotate(-45deg);
			-o-transform: translateY(0) rotate(-45deg);
			transform: translateY(0) rotate(-45deg);
		}

		.nav-is-visible .nav-trigger span:after {
			-webkit-transform: translateY(0) rotate(45deg);
			-moz-transform: translateY(0) rotate(45deg);
			-ms-transform: translateY(0) rotate(45deg);
			-o-transform: translateY(0) rotate(45deg);
			transform: translateY(0) rotate(45deg);
		}

	}

	

	@media (max-width: 900px) {
	    .section-container {
	        width: 100%;
	    }
	}

.section-item {
    text-align: center;
    cursor: pointer;
    outline: none !important;
    margin: 0 !important;
}

@media (max-width: 900px) {
    .section-container {
        width: 100%;
				margin: 15px 0;
    }
}

@media (max-width: 1024px) {

    .section-item.active {
        border: 2px solid var(--quomi-primary);
				border-radius: 5px;
				background: var(--quomi-primary);
    }

		.section-item.active > span{
        color: #fff !important;
    }

    .section-item span{
        margin-top: 10px;
    }
}


.section-item span{
    display: block;
    color: #54545b;
    font-size: 10px;
    font-weight: 700;
    white-space: nowrap;
    margin-top: 3px;
}

.section-item.active span{
    color: var(--quomi-primary);
}


.section-container-box {
    width: 160px;
    border:2px solid transparent; 
    padding: 5px; 
    display: inline-block;
    border-radius: 10px;
}

.section-container-ct:not(.sticky) .section-item.active .section-container-box {
    border:2px solid var(--quomi-primary); 
}



.section-container-ct {
    margin-top: -31px;
    margin-bottom: 20px;
    position: fixed !important;
    left: 0;
    width: 100%;
    z-index: 2;
    background: white;
}


/* .border-top-checkout {
    margin-top: -2px;
    border-top: 2px solid grey
} */

@media (min-width: 1024px) {

    .section-container-ct {
        margin-top: -180px;
    }

		.slider-container {
			margin: 10px auto;
			position: unset !important;
			}

    .border-top-checkout {
        margin-top: 10px;
    }
}

@media(min-width: 1025px) and (max-width: 1920px){
	.section-container-box {
		width: 90%;
		margin-right: 7px;
	}

	.section-item span {
    font-size: 10px;
		font-weight: 400;
		margin-top: 10px;
	}
}

@media(min-width: 1920px){
	.section-item {
    display: inline-block;
		width: 120px;
	}

	.section-item span {
    font-size: 10px;
		font-weight: 400;
		margin-top: 10px;
	}
}
</style>

<style>
    .slick-slide {
        outline: none !important;
    }
    .slick-track {
        margin: auto;
    }
    .slider-arrow {
        box-shadow: none !important;
    }
    .items-container {
        padding: 0 !important;
    }

    .slick-slide:not(.slick-active) {
        height: 0;
    }
</style>
